import { render } from "./FishTableView.vue?vue&type=template&id=47e8cf40"
import script from "./FishTableView.vue?vue&type=script&lang=js"
export * from "./FishTableView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__